'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "gapSize"];
import PropTypes from 'prop-types';
import UIButtonWrapper from '../layout/UIButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIColorSquatchGrid(_ref) {
  let {
      children,
      gapSize
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(UIButtonWrapper, {
      horizontalGap: gapSize,
      verticalGap: gapSize,
      "data-test-id": "button-wrapper",
      children: children
    })
  }));
}
UIColorSquatchGrid.propTypes = {
  children: PropTypes.node,
  gapSize: PropTypes.number
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIColorSquatchGrid.defaultProps = {
  gapSize: 6
};
UIColorSquatchGrid.displayName = 'UIColorSquatchGrid';